import React from "react";
import { Button, Modal, Result } from "antd";
import { useNavigate } from "react-router-dom";

interface NoAccessProps {
  openPopup?: boolean;
  popupMessage?: string;
}
const NoAccessPopup: React.FC<NoAccessProps> = ({
  openPopup = false,
  popupMessage = "Sorry, you are not authorized to access this page.",
}) => {
  const navigate = useNavigate();

  return (
    <Modal
      centered
      open={openPopup}
      footer={null}
      closable={false}
      style={{ scale: "0.8" }}
    >
      <Result
        status="403"
        title={
          <div style={{ fontSize: "17px", fontWeight: 600 }}>
            {popupMessage}
          </div>
        }
        extra={
          <Button
            size="large"
            type="primary"
            onClick={() => {
              navigate("/home");
            }}
          >
            Back Home
          </Button>
        }
      />
    </Modal>
  );
};

export default NoAccessPopup;
